import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getPaymentMethodsTypes = (): Promise<ISelectModel<string>[]> =>
  API.get('api/accommodation/payment-methodtypes').then(response => response?.data);
